import styles from "../../styles/tabs.module.scss";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const Tabs = ({ tabs, onTabSelected, activeTab, full }) => {
  const scrollToTab = (e, tabKey) => {
    e.target.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });

    onTabSelected(tabKey);
  };

  return (
    <ul className={styles.tabsContainer}>
      {tabs.map((tab) => {
        return (
          <li
            key={tab.key}
            onClick={(e) => scrollToTab(e, tab.key)}
            className={css({
              tab: true,
              active: activeTab === tab.key,
              full: full,
              disabled: tab.disabled,
            })}
          >
            {tab.name}
          </li>
        );
      })}
    </ul>
  );
};
